class UOMModel {
    uomId?:number;
    name?: string;
    shortName?: string;
   
}
export default UOMModel;